import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15 7A6.764 6.764 0 008 .5 6.764 6.764 0 001 7a6.764 6.764 0 007 6.5c.48 0 .959-.046 1.43-.137L13 15.5v-4A6.568 6.568 0 0015 7v0z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.94 5.029A1.95 1.95 0 008 5.345a1.95 1.95 0 00-2.941-.316 1.814 1.814 0 00-.06 2.564l.056.054L8 10.5l2.94-2.852A1.813 1.813 0 0011 5.084l-.06-.055z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }